import { render, staticRenderFns } from "./PostHome.vue?vue&type=template&id=2f58837c&scoped=true&"
import script from "./PostHome.vue?vue&type=script&lang=js&"
export * from "./PostHome.vue?vue&type=script&lang=js&"
import style0 from "./PostHome.vue?vue&type=style&index=0&id=2f58837c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f58837c",
  null
  
)

export default component.exports